import {CardText} from "material-ui/Card"
import {FormattedMessage} from "react-intl"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import TextField from "material-ui/TextField"
import Button from "material-ui/RaisedButton"
import React from "react"
import * as Util from "../common"
import {containers} from "@swarm2/core"

const M = props => (
  <FormattedMessage {...props} id={"view.BetaKeyCreateView." + props.id} />
)

// To grant access to this page: /userRoles/betaKeys/$userId
//
// To bootstrap a new environment with no accounts:
// * Visit /beta/join/x. Invalid key, but it'll create an anonymous account.
//   (/start is blocked during beta.) Tells you the account id too, no need to
//   dig into cookies.)
// * Firebase console > create: key: /userRoles/betaKeys/$userId , value: true
// * visit /beta/create, create a beta key, use it on self
function BetaKeyCreateRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {count, input, isSubmitAllowed, onSubmit, formErrors, betaKeys} = props
  //const keyUrls = betaKeys.map(key => location.host + )
  const keyUrls = betaKeys.map(
    key => window.location.origin + "/#/beta/join/" + key,
  )
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <form onSubmit={isSubmitAllowed ? onSubmit : undefined}>
          <div>
            <TextField
              name="count"
              type="number"
              value={count}
              onChange={input.setCount}
            />
          </div>
          <div>
            <Button
              primary
              disabled={!isSubmitAllowed}
              label={"Create " + count}
              onClick={onSubmit}
            />
          </div>
          <div>
            {formErrors.map(error => (
              <pre key={error}>{JSON.stringify(error)}</pre>
            ))}
          </div>
          <div>{keyUrls.map(url => <div key={url}>{url}</div>)}</div>
        </form>
      </CardText>
    </div>
  )
}
export default containers.beta.BetaKeyCreate(BetaKeyCreateRender)



// WEBPACK FOOTER //
// ./src/beta/BetaKeyCreateView.js